<script setup>
import { HrSwitch } from '../primitives';

/**
 * Visibility switch — a binary toggle with visibility/visibility_off icons.
 *
 * @status recommended
 * @group forms-input
 * @useWhen Toggling the visibility of content or a setting
 * @related HrOnOffSwitch
 * @related HrSettingSwitch
 * @a11y Native switch role; activates with Space. Icons reinforce visibility state beyond color alone.
 * @event update:modelValue Forwarded from HrSwitch; new boolean value.
 */
defineOptions({ name: 'HrVisibilitySwitch' });

defineProps({
  /** Current visibility state. */
  modelValue: {
    type: Boolean,
    default: false,
  },
  /** Optional text label displayed alongside the switch. */
  label: {
    type: String,
    default: null,
  },
  /** Prevents interaction and dims the switch. */
  disable: {
    type: Boolean,
    default: false,
  },
});
</script>
<template>
  <hr-switch
    icon-on="visibility"
    icon-off="visibility_off"
    v-bind="{ ...$props, ...$attrs }"
  />
</template>
